(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/coupon-row-sections.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/coupon-row-sections.js');
"use strict";


const CouponRowHeader = _ref => {
  let children = _ref.children,
    className = _ref.className;
  return React.createElement("header", {
    className: "pg_coupon_row_header ".concat(className || '').trim()
  }, children);
};
const CouponRowBody = _ref2 => {
  let children = _ref2.children,
    className = _ref2.className;
  return React.createElement("div", {
    className: "pg_coupon_row_body ".concat(className || '').trim()
  }, children);
};
const CouponRowFooter = _ref3 => {
  let children = _ref3.children,
    className = _ref3.className;
  return React.createElement("footer", {
    className: "pg_coupon_row_footer ".concat(className || '').trim()
  }, children);
};
setGlobal('svs.components.tipsen.couponScore.couponRowSections', {
  CouponRowHeader,
  CouponRowBody,
  CouponRowFooter
});

 })(window);